import Crud from "../Crud";
import { purple } from "@mui/material/colors";

/**
 * Static helper functions related to Roles.
 */
export default class Role extends Crud {
  /**
   * @param {object} role The role object.
   * @returns The display name of the role.
   */
  static getDisplayName(role) {
    return role.name;
  }

  /**
   * Determines if a role matches a search query.
   *
   * @param {object} role The role to test.
   * @param {string} query The search query.
   * @returns {boolean} Whether or not the role matches the query.
   */
  static match(role, query) {
    const displayName = Role.getDisplayName(role).toLowerCase();
    return displayName.includes(query) || role.id === +query;
  }

  /**
   * @param {array} roles The list to sort.
   * @returns {array} The sorted list.
   */
  static sort(roles) {
    return roles.sort((a, b) => {
      return Role.getDisplayName(a).localeCompare(Role.getDisplayName(b));
    });
  }

  /**
   * @returns {object} The color of this object.
   */
  static getBaseColor() {
    return purple;
  }

  /**
   * @returns {string} The icon name for this object.
   */
  static getIconName() {
    return "Security";
  }
}
